import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FolderOpen } from 'lucide-react';

// ✅ Static folder list
const FOLDERS = [
  { id: "13VaK8YqaGpYB4Qu8usYu3rU6nN9Ibbxy", name: "Opening Ceremony" },
  { id: "1PiNAYOgR99WEpkcxpdZYU-UzmbYG1z5o", name: "People of RenAIssance" },
  { id: "1XeC4fTnyXdrCTmis7Wg7LgqKWSTSs13G", name: "Product Showcase" },
  { id: "1sd0OaMRnkiBEqn1WKmWUEJB1FtOkVsCW", name: "Panel: When agents meet reality" },
  { id: "1GoAyB4EtzlLSLhC23b4_1qACprZrRiCU", name: "Panel: Video Vs Voice" },
  { id: "1lHZMSF_3IPSKHmdDdmBUggBu6mnV24Vj", name: "Panel: Inside the big tech: Can Big tech reinvent themselves with AI?" },
  { id: "1SvxDXHXpZtd47LuvF33Gbo8VlrqwV47H", name: "Panel: Are AI native startups optimizing or rewriting enterprise?" },
  { id: "1OVvMR4-iDlsruaVjF85eWuzAWuKdQfbK", name: "Fireside: Vibe coding hype Vs Reality" },
  { id: "1htm_OgmQPIXcXJlz994Htk7xavPPswzH", name: "Fireside: Building search for agentic systems" },
  { id: "17ZON1tSoA-OQt9x5kr3ClLGkVoMQeCpu", name: "Fireside: Agents need a new Internet" },
  { id: "1lRa_j1PUn1mP2aKYWlnixNhRUEUBx4tG", name: "Closing Ceremony" }
];

const Gallery = () => {
  const [folders] = useState(FOLDERS);

  // ✅ Open Google Drive folder
  const openFolder = (folderId) => {
    const driveLink = `https://drive.google.com/drive/folders/${folderId}?usp=sharing`;
    window.open(driveLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5] pb-32" data-testid="gallery">
      
      {/* Header */}
      <header className="sticky top-0 z-40 bg-[#F5F5F5]/80 backdrop-blur-xl border-b border-[#082BCC]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img
              src="https://framerusercontent.com/images/Qx3N6D3xDD7B99tP20IHUhGs2U.png"
              alt="AI Plus Logo"
              className="h-10"
            />
            <div>
              <h1 className="font-satoshi font-bold text-2xl text-[#1A1A1A]">
                RenAIssance 2026
              </h1>
              <p className="font-satoshi text-sm text-[#666666]">
                Conference Photo Gallery
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12 text-center"
        >
          <h2 className="font-satoshi font-black text-5xl md:text-7xl text-[#1A1A1A] mb-4">
            Select a Folder
          </h2>
          <p className="font-satoshi text-xl text-[#666666]">
            Choose a session to view photos
          </p>
        </motion.div>

        {/* Folder Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {folders.map((folder, index) => (
            <motion.div
              key={folder.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              onClick={() => openFolder(folder.id)}
              className="group relative bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl hover:shadow-[#082BCC]/20 transition-all cursor-pointer border-2 border-transparent hover:border-[#082BCC]"
            >
              <FolderOpen className="w-12 h-12 text-[#082BCC] mb-4 group-hover:scale-110 transition-transform" />
              
              <h3 className="font-satoshi font-bold text-xl text-[#1A1A1A] mb-2">
                {folder.name}
              </h3>

              <div className="flex items-center text-[#666666] text-sm font-satoshi">
                <span>View Photos →</span>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Gallery;